<template>
    <section class="grid-flex center">

        <div>
            <div class="box-content flex txt-center center">
                <div>
                    <div class="img-warning" style="margin-top: 30px">
                        <img src="@/assets/img/warning-logo.png" width="120">
                    </div>

                    <div class="margin-top-l">
                        <h2>Conta Bloqueada!</h2>
                        <br>
                        <p>Sua conta foi bloqueada por falta de pagamento!</p>
                        <br>
                        <p>Verifique sua assinatura no botão abaixo:</p>
                        <br>
                        <router-link :to="{ name: 'ConfigAccount' }">
                            <div class="button primary">
                                <span>Gerenciar Assinatura</span>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import { mapState } from "vuex";


export default {
    name: 'blocked',
    data() {
        return {
        }
    },
    computed: {
    ...mapState({
          account: (state) => state.account,
    }),
    }
}
</script>

<style lang="css" scoped>
    @keyframes treme {
        0% {margin-left: 0; margin-top: 0}
        25% {margin-left: 5px; margin-top: 5px;}
        50% {margin-left: 0; margin-top: 0;}
        75% {margin-left: -5px; margin-top: -5px;}
        100% {margin-left: 0; margin-top: 0;}
    }

    .box {
        animation: treme 0.3s;
        animation-iteration-count: 4;
    }


</style>
